/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { updatePureWaveSettingRequestModelSchema } from "../updatePureWaveSettingRequestModelSchema.ts";
import { z } from "zod";

/**
 * @description Частота обновлена
 */
export const putApiPurewaveSetting200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const putApiPurewaveSetting400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiPurewaveSetting401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiPurewaveSetting403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Частота не найдена
 */
export const putApiPurewaveSetting404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiPurewaveSetting500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiPurewaveSettingMutationRequestSchema = z.lazy(() => updatePureWaveSettingRequestModelSchema).describe("Тело запроса")

export const putApiPurewaveSettingMutationResponseSchema = z.lazy(() => putApiPurewaveSetting200Schema)